import React, { createContext, useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';

import { NotifContext } from './NotifContext';
import { DrawerContext } from './DrawerContext';
import { ProfileContext } from './ProfileContext';

const blogAPI = process.env.REACT_APP_API;

export const FeedContext = createContext();

const FeedContextProvider = (props) => {
  const randomUser = {
    uid: '',
    picture: '',
    name: {
      fullName: '',
      firstName: '',
      lastName: '',
    },
    createdAt: Date.now(),
  };
  const [articles, setArticles] = useState(new Array(0));
  const [article, setArticle] = useState(new Array(0));
  const [loadingMoreArticles, setLoadingMoreArticles] = useState(false);
  const [addPostLoader, setAddPostLoader] = useState(false);
  const [user, setUser] = useState(randomUser);

  const { show } = useContext(NotifContext);
  const { closeDrawer } = useContext(DrawerContext);
  const {
    profile,
    fetchProfile,
    setIsFollowing,
    loggedin,
    authChecked,
  } = useContext(ProfileContext);
  const re =
    /((?:href|src)=")?(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;

  const config = { withCredentials: true };

  const {
    match: { params },
  } = props;

  // console.log('profile', profile)
  // get first 10 articles on load
  const linkify = (description) => {
    return description.replace(re, (match, attr) => {
      if (typeof attr !== 'undefined') {
        return match;
      }
      const text = match.replace(/(^\w+:|^)\/\//, '');
      return `<a target="_blank" href="${match}">${text}</a>`;
    });
  };

  const updateFeed = (articleArray, location) => {
    let updatedFeed = [];
    switch (location) {
      case 'top':
        updatedFeed = articleArray.concat(articles);
        break;
      case 'bottom':
        updatedFeed = articles.concat(articleArray);
        break;
      case 'refersh':
        updatedFeed = new Array(articleArray);
        break;
      default:
        updatedFeed = articleArray.concat(articles);
    }

    setArticles(updatedFeed);
    if (
      !params.uid ||
      params.uid === JSON.parse(localStorage.getItem('user')).userData.uid
    ) {
      localStorage.setItem(
        'feed',
        JSON.stringify({
          articles: updatedFeed,
          count: updatedFeed.length,
          lastest_update_at: updatedFeed[0].createdAt,
        })
      );
    }
  };

  const getLastestUpdateTime = () => {
    const api = `${blogAPI}/articles/latest`;
    if (localStorage.getItem('loggedin') === 'true' && localStorage.getItem('user')) {
      const currentUser = JSON.parse(localStorage.getItem('user')).userData;
      if (!params.uid || params.uid === currentUser.uid) {
        axios
          .get(api, config)
          .then((res) => {
            const response = res.data;
            if (response.error || response.code === 1) {
              // error notif
              mixpanel.track('Backend Error: Get latest Article', {
                api,
                response,
                has_token: Boolean(config.headers?.Authorization),
              });
              fetchMoreArticles('refresh');
            } else if (
              localStorage.getItem('feed') &&
              response.payload.article.createdAt ===
                JSON.parse(localStorage.getItem('feed')).articles[0].createdAt
            ) {
              setArticles(JSON.parse(localStorage.getItem('feed')).articles);
            } else {
              fetchMoreArticles('refresh');
            }
          })
          .catch((e) => {
            console.log(e);
            mixpanel.track('Error: Get latest Article', {
              api,
              has_token: Boolean(config.headers?.Authorization),
            });
            show('error', 'Error!', 'Something went wrong!', 'bottomRight');
          });
      } else if (params.uid !== currentUser.user_uid) {
        // fetching own profile
        fetchMoreArticles('refresh');
      }
    } else {
      // show login option
      // show(
      //   'info',
      //   'Privileged Access Only',
      //   `You must login to use this feature!`,
      //   'topLeft'
      // );
    }
  };

  const addNewArticles = (articleData) => {
    mixpanel.track('Click: Add Article');
    closeDrawer();
    const payload = articleData;
    payload.postType = 'twitter_card';
    setAddPostLoader(true);
    payload.description = linkify(payload.description);
    const api = `${blogAPI}/articles/add`;
    if (localStorage.getItem('loggedin') === 'true') {
      axios
        .post(api, payload, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            // error notif
            mixpanel.track('Backend Error: Add Article', {
              api,
              response,
              has_token: Boolean(config.headers?.Authorization),
            });
            show('info', 'Error!', response.message, 'bottomRight');
          } else {
            updateFeed(new Array(response.payload.article), 'top');
            fetchProfile(profile.userData.user.uid);
          }
          setAddPostLoader(false);
        })
        .catch((e) => {
          console.log(e);
          mixpanel.track('Error: Add Article', {
            api,
            has_token: Boolean(config.headers?.Authorization),
          });
          show('error', 'Error!', 'Something went wrong!', 'bottomRight');
          setAddPostLoader(false);
        });
    } else {
      // show login option
      show(
        'info',
        'Privileged Access Only',
        `You must login to use this feature!`,
        'topLeft'
      );
    }
  };

  const fetchMoreArticles = (customPointerAction) => {
    let pointer;
    const userQuery = params.uid ? `&user=${params.uid}` : '';
    if (customPointerAction === 'refresh') {
      pointer = 0;
    } else {
      const totalArticles = articles.length;
      pointer = totalArticles >= 1 ? articles.length : 0;
    }

    const api = `${blogAPI}/articles/fetch?pointer=${pointer}${userQuery}`;
    if (localStorage.getItem('loggedin') === 'true') {
      if (pointer > 1 || pointer === 0) {
        setLoadingMoreArticles(true);
        axios
          .get(api, config)
          .then((res) => {
            const response = res.data;
            if (response.error || response.code === 1) {
              // error notif
              mixpanel.track('Backend Error: Get Articles', {
                api,
                response,
                has_token: Boolean(config.headers?.Authorization),
              });
              show('info', 'Error!', response.message, 'bottomRight');
            } else {
              // show('success','Success!',response.message,'topRight');
              updateFeed(
                response.payload.articles,
                customPointerAction === 'refresh' ? 'refresh' : 'bottom'
              );
              setUser(response.payload.user);
              if (response.payload.user.relation) {
                setIsFollowing(
                  response.payload.user.relation.current_user_follows
                );
              }
            }
            setLoadingMoreArticles(false);
          })
          .catch((e) => {
            console.log('e', e);
            mixpanel.track('Error: Get Articles', {
              api,
              has_token: Boolean(config.headers?.Authorization),
            });
            show('error', 'Error!', 'Something went wrong!', 'bottomRight');
            setLoadingMoreArticles(false);
          });
      } else {
        // no need to make request
        show(
          'info',
          'For your information',
          'No more posts available!',
          'bottomRight'
        );
      }
    } else {
      // show login option
      // show(
      //     'info',
      //     'Privileged Access Only',
      //     `You must login to use this feature!`,
      //     'topLeft'
      // );
    }
  };

  useEffect(() => {
    if (authChecked && loggedin) {
      getLastestUpdateTime();
    }
  }, [authChecked, loggedin]);

  return (
    <FeedContext.Provider
      value={{
        articles,
        setArticles,
        article,
        setArticle,
        addNewArticles,
        fetchMoreArticles,
        updateFeed,
        loadingMoreArticles,
        setLoadingMoreArticles,
        addPostLoader,
        setAddPostLoader,
        user,
        setUser,
      }}
    >
      {props.children}
    </FeedContext.Provider>
  );
};

export default withRouter(FeedContextProvider);
